export const switchToSoloSession = context => id => ({
    type: 'WITNESS.SESSION.SOLO',
    payload: {id},
    context
});